{
  "tile_size": 16,
  "floor": [
    [
      0,
      0,
      0
    ],
    [
      0,
      1,
      0
    ],
    [
      0,
      2,
      0
    ],
    [
      0,
      3,
      0
    ],
    [
      0,
      4,
      0
    ],
    [
      0,
      5,
      0
    ],
    [
      1,
      0,
      0
    ],
    [
      1,
      1,
      0
    ],
    [
      1,
      2,
      2
    ],
    [
      1,
      3,
      0
    ],
    [
      1,
      4,
      0
    ],
    [
      1,
      5,
      0
    ],
    [
      2,
      0,
      0
    ],
    [
      2,
      1,
      0
    ],
    [
      2,
      2,
      0
    ],
    [
      2,
      3,
      0
    ],
    [
      2,
      4,
      0
    ],
    [
      2,
      5,
      0
    ],
    [
      3,
      0,
      0
    ],
    [
      3,
      1,
      0
    ],
    [
      3,
      2,
      0
    ],
    [
      3,
      3,
      0
    ],
    [
      3,
      4,
      0
    ],
    [
      3,
      5,
      0
    ],
    [
      4,
      0,
      0
    ],
    [
      4,
      1,
      0
    ],
    [
      4,
      2,
      0
    ],
    [
      4,
      3,
      0
    ],
    [
      4,
      4,
      0
    ],
    [
      4,
      5,
      0
    ],
    [
      5,
      0,
      0
    ],
    [
      5,
      1,
      0
    ],
    [
      5,
      2,
      0
    ],
    [
      5,
      3,
      0
    ],
    [
      5,
      4,
      0
    ],
    [
      5,
      5,
      0
    ],
    [
      6,
      0,
      0
    ],
    [
      6,
      1,
      0
    ],
    [
      6,
      2,
      0
    ],
    [
      6,
      3,
      0
    ],
    [
      6,
      4,
      0
    ],
    [
      6,
      5,
      0
    ],
    [
      7,
      0,
      0
    ],
    [
      7,
      1,
      0
    ],
    [
      7,
      2,
      0
    ],
    [
      7,
      3,
      0
    ],
    [
      7,
      4,
      0
    ],
    [
      7,
      5,
      0
    ],
    [
      8,
      0,
      0
    ],
    [
      8,
      1,
      0
    ],
    [
      8,
      2,
      0
    ],
    [
      8,
      3,
      0
    ],
    [
      8,
      4,
      0
    ],
    [
      8,
      5,
      0
    ],
    [
      9,
      0,
      0
    ],
    [
      9,
      1,
      0
    ],
    [
      9,
      2,
      0
    ],
    [
      9,
      3,
      0
    ],
    [
      9,
      4,
      0
    ],
    [
      9,
      5,
      0
    ],
    [
      10,
      0,
      0
    ],
    [
      10,
      1,
      0
    ],
    [
      10,
      2,
      0
    ],
    [
      10,
      3,
      0
    ],
    [
      10,
      4,
      0
    ],
    [
      10,
      5,
      0
    ],
    [
      11,
      0,
      4
    ],
    [
      11,
      1,
      0
    ],
    [
      11,
      2,
      0
    ],
    [
      11,
      3,
      0
    ],
    [
      11,
      4,
      0
    ],
    [
      11,
      5,
      0
    ]
  ],
  "walls": [
    [0, 0, 3],
    [0, 1, 5],
    [0, 7, 3],
    [1, 0, 0],
    [1, 1, 5],
    [1, 7, 3],
    [2, 0, 3],
    [2, 1, 11],
    [2, 7, 3],
    [3, 0, 3],
    [3, 1, 5],
    [3, 7, 3],
    [4, 0, 3],
    [4, 1, 5],
    [4, 7, 3],
    [5, 0, 3],
    [5, 1, 10],
    [5, 7, 3],
    [6, 0, 3],
    [6, 1, 5],
    [6, 7, 3],
    [7, 0, 3],
    [7, 1, 5],
    [7, 7, 3],
    [8, 0, 3],
    [8, 1, 5],
    [8, 7, 3],
    [9, 0, 3],
    [9, 1, 5],
    [9, 7, 3],
    [10, 0, 3],
    [10, 1, 5],
    [10, 7, 3],
    [11, 0, 3],
    [11, 1, 8],
    [11, 7, 3]
  ],
  "fountains": [
    {
      "x": 3,
      "y": -0.5
    },
    {
      "x": 9,
      "y": -0.5
    }
  ],
  "waves": [
    {
      "spawnSpeed": 0.005,
      "enemies": [
        {
          "name": "skeleton",
          "count": 20
        }
      ]
    },
    {
      "spawnSpeed": 0.01,
      "enemies": [
        {
          "name": "skeleton",
          "count": 10
        },
        {
          "name": "slime",
          "count": 10
        }
      ]
    },
    {
      "spawnSpeed": 0.01,
      "enemies": [
        {
          "name": "slime",
          "count": 5
        },
        {
          "name": "chort",
          "count": 5
        }
      ]
    }
  ],
  "chests": [0,1,2,3,4,5]
}
